var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-notice-bar',{attrs:{"scrollable":false}},[_vm._v(" 您访问的页面未找到！ ")])
}
var staticRenderFns = []

export { render, staticRenderFns }